function validateName(name: string, fullName?: boolean): boolean {
  const spacing = /\s/;
  if (fullName && spacing.test(name) && name.length > 4) {
    return true;
  }
  return false;
}

export default validateName;
